// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, FreeMode } from "swiper/modules";

function sliders() {
	threeCardSlider();
}
function basicSlider() {
	const slider = new Swiper(".basic-slider", {
		modules: [Navigation, Pagination, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: true,
		},
		allowTouchMove: true,
		effect: "slide",
		spaceBetween: 20,
		slidesPerView: 1,

		pagination: {
			el: ".swiper-pagination",
			type: "bullets", // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			992: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
		},
	});
}
function threeCardSlider() {
	const sliders = document.querySelectorAll('[data-name="3-card-slider"]');

	if (sliders.length > 0) {
		// Starting point
		sliders.forEach((sliderItem) => {
			let swiperContain = sliderItem.closest("[data-swiper-contain]");
			let name = swiperContain.dataset.swiperContain;
			const slider = new Swiper(sliderItem, {
				modules: [Navigation, Pagination, Autoplay, FreeMode],
				loop: false,
				draggable: true,
				freeMode: {
					enabled: false,
				},
				allowTouchMove: true,
				effect: "slide",
				spaceBetween: 20,
				slidesPerView: 1,

				pagination: {
					el: ".swiper-pagination",
					type: "bullets", // bullets, fraction (ex. 1/10), progressbar
					clickable: true,
				},
				navigation: {
					nextEl: "[data-next='" + name + "']",
					prevEl: "[data-previous='" + name + "']",
				},

				breakpoints: {
					760: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					1380: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				},
			});
		});
	}
}

export default sliders;
